<template>
  <v-dialog v-model="open" max-width="500">
    <v-card class="pa-4">
      <v-card-title class="headline px-0 pt-0" style="word-break: break-word">{{ heading ? heading : $t('sure_to_delete') }}</v-card-title>
      <v-card-text class="px-0 pt-0">{{ message ? message : $t('cant_restore') }}</v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <v-btn color="error" @click="$emit('onConfirm')">{{ $t('yes') }}</v-btn>
        <v-btn color="primary" @click="open = false">{{ $t('cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['heading', 'message', 'onConfirm'],
  data() {
    return {
      open: false
    }
  },
  methods: {
    openDialog() {
      this.open = true
    },
    close() {
      this.open = false
    }
  }
}
</script>
